import DesktopApp from "./components/DesktopApp";
import MobileApp from "./components/MobileApp";
import { useWindowDimensions } from "./hooks/useWindowDimensions";

function App() {
  const { height, width } = useWindowDimensions();
  return width > 768 ? <DesktopApp /> : <MobileApp />;
}

export default App;
